import React from 'react';
export default function FormClosedIcon({
  width = 392,
  height = 169,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 392 169'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M231.826 152.779C218.53 153.096 202.702 152.779 191.464 152.621C180.226 152.937 164.397 153.096 151.102 152.779C164.239 145.34 168.671 131.569 169.462 122.389H213.307C214.257 131.569 218.688 145.34 231.826 152.779Z'
        fill='#F1F3F9'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M273.931 5.90678V119.712C273.931 122.561 271.715 124.619 269.024 124.619H113.907C111.216 124.619 109 122.403 109 119.712V5.90678C109 3.21597 111.216 1 113.907 1H269.024C271.715 1 273.931 3.05768 273.931 5.90678Z'
        fill='white'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinejoin='round'
      />
      <path
        d='M273.929 5.90678V104.042H109.156V5.90678C109.156 3.21597 111.372 1 114.063 1H269.18C271.713 1 273.929 3.05768 273.929 5.90678Z'
        fill='#F1F3F9'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path d='M268.06 7H115V98.3293H267.901V7H268.06Z' fill='white' />
      <path
        d='M191.467 118.287C193.74 118.287 195.582 116.445 195.582 114.172C195.582 111.899 193.74 110.057 191.467 110.057C189.194 110.057 187.352 111.899 187.352 114.172C187.352 116.445 189.194 118.287 191.467 118.287Z'
        fill='#D6DCE8'
      />
      <path
        d='M1 152H390.975'
        stroke='#CDD6E1'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M122.66 167.157H332.936'
        stroke='#CDD6E1'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M54.2656 167.157H80.8389'
        stroke='#CDD6E1'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M72.2896 111H67.3828V151.046H72.2896V111Z'
        fill='#F1F3F9'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinejoin='round'
      />
      <path
        d='M107.11 111H102.203V151.046H107.11V111Z'
        fill='#F1F3F9'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinejoin='round'
      />
      <path
        d='M113.284 112.899H62V129.361H113.284V112.899Z'
        fill='white'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M74.3476 112.899L68.966 129.203H62.793L68.1746 112.899H74.3476Z'
        fill='#D6DCE8'
      />
      <path
        d='M86.8515 112.899L81.4699 129.203H75.2969L80.5202 112.899H86.8515Z'
        fill='#D6DCE8'
      />
      <path
        d='M99.3554 112.899L93.9738 129.203H87.8008L93.0241 112.899H99.3554Z'
        fill='#D6DCE8'
      />
      <path
        d='M111.859 112.899L106.478 129.203H100.305L105.528 112.899H111.859Z'
        fill='#D6DCE8'
      />
      <path
        d='M304.29 111H299.383V151.046H304.29V111Z'
        fill='#F1F3F9'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinejoin='round'
      />
      <path
        d='M339.11 111H334.203V151.046H339.11V111Z'
        fill='#F1F3F9'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinejoin='round'
      />
      <path
        d='M345.284 112.899H294V129.361H345.284V112.899Z'
        fill='white'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M306.348 112.899L300.966 129.203H294.793L300.175 112.899H306.348Z'
        fill='#D6DCE8'
      />
      <path
        d='M318.852 112.899L313.47 129.203H307.297L312.52 112.899H318.852Z'
        fill='#D6DCE8'
      />
      <path
        d='M331.355 112.899L325.974 129.203H319.801L325.024 112.899H331.355Z'
        fill='#D6DCE8'
      />
      <path
        d='M343.859 112.899L338.478 129.203H332.305L337.528 112.899H343.859Z'
        fill='#D6DCE8'
      />
      <path
        d='M143.794 151.167H122.426L123.375 148.793L125.591 142.778L127.491 137.555L129.707 131.54L131.29 127.425C131.606 126.633 132.398 126 133.189 126C133.98 126 134.772 126.475 135.088 127.425L136.671 131.54L138.887 137.555L140.787 142.778L143.003 148.793L143.794 151.167Z'
        fill='white'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M138.894 137.555H127.504L129.644 131.698H136.722L138.894 137.555Z'
        fill='#D6DCE8'
      />
      <path
        d='M142.994 148.793H123.367L125.583 142.778H140.778L142.994 148.793Z'
        fill='#D6DCE8'
      />
      <path
        d='M143.793 151.167H122.266C121.633 151.167 121 150.692 121 149.901C121 149.268 121.475 148.635 122.266 148.635H143.793C144.426 148.635 145.059 149.11 145.059 149.901C145.059 150.692 144.584 151.167 143.793 151.167Z'
        fill='white'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M288.794 151.167H267.426L268.375 148.793L270.591 142.778L272.491 137.555L274.707 131.54L276.29 127.425C276.606 126.633 277.398 126 278.189 126C278.98 126 279.772 126.475 280.088 127.425L281.671 131.54L283.887 137.555L285.787 142.778L288.003 148.793L288.794 151.167Z'
        fill='white'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M283.894 137.555H272.504L274.644 131.698H281.722L283.894 137.555Z'
        fill='#D6DCE8'
      />
      <path
        d='M287.994 148.793H268.367L270.583 142.778H285.778L287.994 148.793Z'
        fill='#D6DCE8'
      />
      <path
        d='M288.793 151.167H267.266C266.633 151.167 266 150.692 266 149.901C266 149.268 266.475 148.635 267.266 148.635H288.793C289.426 148.635 290.059 149.11 290.059 149.901C290.059 150.692 289.584 151.167 288.793 151.167Z'
        fill='white'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M44.794 151.167H23.4258L24.3755 148.793L26.5914 142.778L28.4908 137.555L30.7068 131.54L32.2896 127.425C32.6062 126.633 33.3976 126 34.189 126C34.9804 126 35.7719 126.475 36.0884 127.425L37.6713 131.54L39.8872 137.555L41.7866 142.778L44.0026 148.793L44.794 151.167Z'
        fill='white'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M39.8935 137.555H28.5039L30.6443 131.698H37.7224L39.8935 137.555Z'
        fill='#D6DCE8'
      />
      <path
        d='M43.9943 148.793H24.3672L26.5831 142.778H41.7783L43.9943 148.793Z'
        fill='#D6DCE8'
      />
      <path
        d='M44.7928 151.167H23.2663C22.6331 151.167 22 150.692 22 149.901C22 149.268 22.4749 148.635 23.2663 148.635H44.7928C45.4259 148.635 46.059 149.11 46.059 149.901C46.059 150.692 45.5842 151.167 44.7928 151.167Z'
        fill='white'
        stroke='#D6DCE8'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M222.208 40.1087L177.485 23.2685L160.68 67.9756'
        stroke='#AAB2C5'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinejoin='round'
      />
      <path
        d='M233.869 63.3611L170.426 92.0953C167.571 93.3885 164.232 92.1312 162.938 89.2759L152.908 67.1299C151.615 64.2746 152.872 60.9356 155.728 59.6424L219.206 30.8924C222.061 29.5992 225.4 30.8565 226.693 33.7118L236.739 55.8926C237.982 58.7288 236.725 62.0679 233.869 63.3611Z'
        fill='white'
        stroke='#AAB2C5'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinejoin='round'
      />
      <path
        d='M178.777 26.1238C180.546 25.3224 181.331 23.2386 180.53 21.4694C179.728 19.7001 177.645 18.9154 175.875 19.7168C174.106 20.5181 173.321 22.6019 174.123 24.3712C174.924 26.1404 177.008 26.9251 178.777 26.1238Z'
        fill='white'
        stroke='#AAB2C5'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinejoin='round'
      />
      <path
        d='M170.605 76.825C169.204 76.3265 168.199 75.3128 167.537 73.8503C166.859 72.353 166.794 70.9135 167.343 69.5317C167.877 68.1152 168.891 67.1105 170.283 66.4797C172.059 65.6754 173.989 65.7666 175.411 66.5911L174.672 68.4787C173.48 67.8855 172.319 67.8238 171.239 68.3127C170.369 68.707 169.745 69.3673 169.421 70.2274C169.097 71.0874 169.131 71.9954 169.556 72.9356C169.967 73.8409 170.576 74.446 171.436 74.7698C172.296 75.0937 173.154 75.0411 174.059 74.631C175.208 74.1106 175.928 73.1973 176.268 71.9102L178.178 72.5138C177.824 74.1426 176.617 75.7386 174.806 76.5587C173.394 77.2401 171.971 77.3394 170.605 76.825Z'
        fill='#AAB2C5'
      />
      <path
        d='M180.4 73.8993L175.969 64.1147L177.954 63.2158L181.533 71.1201L186.478 68.8806L187.33 70.761L180.4 73.8993Z'
        fill='#AAB2C5'
      />
      <path
        d='M188.452 68.7C187.035 68.1666 186.012 67.2034 185.365 65.7758C184.719 64.3481 184.67 62.9434 185.187 61.4921C185.721 60.0755 186.703 59.0012 188.131 58.3546C189.558 57.708 190.998 57.6435 192.43 58.2118C193.847 58.7452 194.921 59.7273 195.552 61.1202C196.183 62.513 196.231 63.9177 195.679 65.3848C195.146 66.8014 194.148 67.8408 192.72 68.4874C191.308 69.1689 189.869 69.2333 188.452 68.7ZM191.633 60.2512C190.773 59.9273 189.9 59.9451 189.064 60.3236C188.194 60.7179 187.639 61.3467 187.316 62.2068C186.992 63.0668 187.06 63.959 187.454 64.8295C187.849 65.7001 188.474 66.34 189.334 66.6638C190.194 66.9877 191.052 66.935 191.922 66.5408C192.793 66.1465 193.398 65.5367 193.722 64.6767C194.046 63.8166 193.993 62.9592 193.583 62.0539C193.138 61.1643 192.493 60.575 191.633 60.2512Z'
        fill='#AAB2C5'
      />
      <path
        d='M197.714 64.0429L198.214 62.1803C199.235 62.7669 200.43 62.8128 201.405 62.3713C202.206 62.0085 202.609 61.3226 202.325 60.6958C202.152 60.3128 201.715 60.0907 200.997 60.0803C200.826 60.0737 200.466 60.1112 199.849 60.1388C199.267 60.1507 198.805 60.1501 198.463 60.1369C197.15 60.0181 196.3 59.438 195.827 58.3934C195.449 57.5577 195.462 56.7542 195.837 55.9132C196.211 55.0722 196.886 54.4309 197.861 53.9893C199.114 53.4216 200.399 53.3853 201.664 53.8616L201.266 55.7624C200.44 55.4227 199.428 55.5036 198.697 55.8348C197.931 56.1818 197.617 56.7856 197.869 57.3427C198.042 57.7257 198.463 57.913 199.111 57.955L200.276 57.9312C200.927 57.8878 201.389 57.8884 201.696 57.9173C203.063 57.9698 203.983 58.5183 204.471 59.5978C204.866 60.4683 204.884 61.3415 204.474 62.1983C204.065 63.055 203.321 63.7279 202.276 64.201C200.709 64.9107 199.051 64.8641 197.714 64.0429Z'
        fill='#AAB2C5'
      />
      <path
        d='M207.318 61.7086L202.887 51.924L209.503 48.9276L210.323 50.7382L205.657 52.8515L206.603 54.9407L210.921 52.9852L211.741 54.7959L207.423 56.7514L208.417 58.9451L213.083 56.8318L213.903 58.6425L207.287 61.639L207.318 61.7086Z'
        fill='#AAB2C5'
      />
      <path
        d='M215.744 57.8921L211.312 48.1074L215.143 46.3727C216.605 45.7103 217.959 45.6425 219.189 46.1345C220.419 46.6266 221.373 47.6212 222.067 49.1533C222.745 50.6506 222.864 52.0238 222.387 53.2886C221.946 54.5376 220.967 55.5264 219.47 56.2046L215.744 57.8921ZM216.842 55.1286L218.723 54.277C219.558 53.8985 220.094 53.3203 220.278 52.5233C220.479 51.7611 220.391 50.9195 219.997 50.049C219.603 49.1785 219.044 48.5925 218.339 48.2403C217.634 47.8882 216.83 47.8745 215.994 48.253L214.114 49.1046L216.842 55.1286Z'
        fill='#AAB2C5'
      />
    </svg>
  );
}
